import { AdminTemplate, DailyAccountHistoryFilter } from "../../components";

export const DailyAccountHistory = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Günlük Hesap Hareketleri",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
      <DailyAccountHistoryFilter />
    </AdminTemplate>
  );
};